// extracted by mini-css-extract-plugin
export var style_component = "AppLayout-module--style_component--dd134 typography-module--typeface_base--8d193";
export var style_header = "AppLayout-module--style_header--d2dc8";
export var style_hideOverflow = "AppLayout-module--style_hideOverflow--30316";
export var style_main = "AppLayout-module--style_main--d2a5a";
export var style_notification = "AppLayout-module--style_notification--71d5f";
export var typeface_base = "typography-module--typeface_base--8d193";
export var typography = "\"@theme/typography.module.css\"";